export default {
  Revenue_SignUpPage_Clicked_SignUpButton: 'Revenue_SignUpPage_Clicked_SignUpButton',
  Revenue_SignUpPage_Clicked_SignInButton: 'Revenue_SignUpPage_Clicked_SignInButton',
  Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox:
    'Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox',
  Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox:
    'Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox',

  Revenue_TaggingPage_Clicked_WhatDoYouDoDropdown:
    'Revenue_TaggingPage_Clicked_WhatDoYouDoDropdown',
  Revenue_TaggingPage_Selected_WhatDoYouDoDropdownOption:
    'Revenue_TaggingPage_Selected_WhatDoYouDoDropdownOption',
  Revenue_TaggingPage_Typed_OtherRole: 'Revenue_TaggingPage_Typed_OtherRole',

  Revenue_TaggingPage_Selected_WhatDoesYourCompanyDoPill:
    'Revenue_TaggingPage_Selected_WhatDoesYourCompanyDoPill',
  Revenue_TaggingPage_Unselected_WhatDoesYourCompanyDoPill:
    'Revenue_TaggingPage_Unselected_WhatDoesYourCompanyDoPill',
  Revenue_TaggingPage_ClickedOn_WhatDoesYourCompanyDoPill:
    'Revenue_TaggingPage_ClickedOn_WhatDoesYourCompanyDoPill',

  Revenue_TaggingPage_Selected_HowWillYouUseThisPill:
    'Revenue_TaggingPage_Selected_HowWillYouUseThisPill',
  Revenue_TaggingPage_Unselected_HowWillYouUseThisPill:
    'Revenue_TaggingPage_Unselected_HowWillYouUseThisPill',
  Revenue_TaggingPage_ClickedOn_HowWillYouUseThisPill:
    'Revenue_TaggingPage_ClickedOn_HowWillYouUseThisPill',

  Revenue_TaggingPage_Clicked_SignUpPlanButton: 'Revenue_TaggingPage_Clicked_SignUpPlanButton',
  Revenue_TaggingPage_Clicked_Next: 'Revenue_TaggingPage_Clicked_Next',
  Revenue_TaggingPage_Clicked_ProgressBar: 'Revenue_TaggingPage_Clicked_ProgressBar',

  Revenue_TaggingPage_Viewed_Page: 'Revenue_TaggingPage_Viewed_Page'
}
